/*
 * Copyright (c) 2026, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import type { ClassValue } from "clsx"
import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * Combines class names and resolves conflicting Tailwind utilities.
 *
 * This is the local `cn` helper used by shadcn components. It combines the
 * inputs with `clsx` and uses `tailwind-merge` so later conflicting utilities
 * override earlier ones, e.g. `px-3` replaces `px-2` (docs/adr/0003).
 *
 * @param inputs - Class names and conditional class values.
 * @returns The merged class name string.
 *
 * @example
 * cn("px-2", "px-3") // "px-3"
 * cn("form-control", { "is-invalid": hasError }) // "form-control is-invalid"
 *
 * @todo Replace this shim with https://github.com/shadcn-ui/cn package once
 * it reaches v1. Re-evaluate the bundle size and conflict coverage before switching; our
 * custom setup deliberately uses `tailwind-merge` rather than a hand-written
 * conflict table.
 */
export function cn(...inputs: ClassValue[]): string {
    return twMerge(clsx(inputs))
}
